module.exports = __webpack_public_path__ + "img/null_score1.23b8508a.png";